export enum BRAINTREE_STATUS {
  INIT,
  LOADING,
  ERROR,
  COMPLETE,
}
